<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Cargo Delivery</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>

        <v-row>
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="orders" :search="search">
              <template v-slot:item.cargo="{ item }">
                <v-btn color="blue" text :to="`/cargo-delivery/${item.id}`">
                {{item.cargo.Name}}
                </v-btn>
              </template>
              <template v-slot:item.document.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}</span>
              </template>
              <template v-slot:item.DocStatus="{ item }">
                <span style="color: red" v-if="item.DocStatus == 0">Open</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/cargo-delivery/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      // { text: "Doc No.", value: "DocNum" },
      { text: "Cargo", value: "cargo" },
      { text: "Supplier", value: "ocrd.Name" },
      { text: "Stock Value", value: "document.DocTotal" },
      { text: "Date", value: "DocDate" },
      { text: "Cargo Status", value: "DocStatus" },
      { text: "View Details", value: "action" },
    ],
    orders: [],
  }),
  methods: {
    getOrders() {
      const self = this;
      this.$store
        .dispatch("get", `/documents/24`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.orders = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getOrders();
  },
};
</script>